import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { InsuredParticipantListDto } from '@/features/dashboard/insurances/types/InsuredParticipantListDto.ts';

const insuredParticipantsApi = {
  getAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<InsuredParticipantListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<InsuredParticipantListDto>>(
      'POST',
      `insured-participants/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `insured-participants/table-definition`,
    );
  },
  getAllByClient: async (
    clientId: string,
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<InsuredParticipantListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<InsuredParticipantListDto>>(
      'POST',
      `clients/${clientId}/insured-participants/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDefinitionByClient: async (
    clientId: string,
  ): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `clients/${clientId}/insured-participants/table-definition`,
    );
  },
};

export default insuredParticipantsApi;
